import React from 'react';
import { FormattedMessage } from 'react-intl';

import { isFullRemoteOnlyByQueryParam } from '@/domain/search/helpers';

import { useSearchQuery } from '../../../contexts';
import { useSearch } from '../../../hooks/use-search';

import * as S from '../query-tags.styles';

export const QueryTagLocation: React.FC = () => {
  const {
    queryParams: [params, setQueryParams],
  } = useSearchQuery();
  const { data } = useSearch();

  // We get the whole location from X1. We need to obtain the city name in case only the cityId is used
  const location = data?.jobSearchByQuery?.searchQuery.body?.location;
  const locationText = location?.city?.name || location?.text || params.location;
  const radiusText = location?.radius ?? params.radius;
  const hasLocationParams = params.location || params.cityId;
  const isFullRemote = isFullRemoteOnlyByQueryParam(params.remoteOption);

  const onDelete = (): void => setQueryParams({ location: undefined, cityId: undefined, radius: undefined });

  // We instantly remove the location params on delete (this will trigger a new X1 query)
  // In order to remove the tag immediately, we check for the existence of these params, so we don't need to wait for the X1 response
  return hasLocationParams && locationText ? (
    <S.Tag variant="delete" onDelete={onDelete} disabled={isFullRemote} data-cy="search-query-tag-location">
      <FormattedMessage id="SE_SUMMARY_JOBS_LOCATION_LABEL" />:{' '}
      {`${locationText}${radiusText ? ` (${radiusText} km)` : ''}`}
    </S.Tag>
  ) : null;
};
